export default "__VITE_ASSET__7COZ3tFQ__"